/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Logic from 'fierry/data/logic';

import AccountCass from 'solis/logic/account/cass';

import BoardCass from 'solis/logic/board/cass';
import BoardRanges from 'solis/logic/board/ranges';
import BoardScore from 'solis/logic/board/score';

import BoardEdgeDistance from 'solis/claude/logic/board/edge.distance';


export default class GalaxyDiscovery extends Logic
{
  getOpenBoards (account, now)
  {
    return this.object.getBoards().values().filter(board =>
    {
      const cass = new BoardCass(board);

      return cass.hasEnoughDurationForAttach(now) && cass.isAccountWithinTerritoryRange(account, this.object);
    });
  }


  getOpenBoardsByRemainingAuthority (account, now)
  {
    const entries = this.getOpenBoards(account, now).map(board => ({ board, authority: this.getRemainingAuthority(board, now) }));

    return entries.sort((lhs, rhs) => rhs.authority - lhs.authority);
  }


  getRemainingAuthority (board, now)
  {
    return this.getDepthWeightedAuthority(board) * new BoardCass(board).getRemainingScoreCount(now);
  }


  getDepthWeightedAuthority (board)
  {
    const score = new BoardScore(board);
    const edge = new BoardEdgeDistance(board);

    return board.getZones().values().reduce((total, zone) => total + score.getZoneAuthority(zone) / edge.getDistance(zone.getAbsoluteHex()), 0);
  }


  getBoardDifficulty (board, account)
  {
    const territory = new AccountCass(account, this.object).getScore().cass.territory;

    const users = new BoardRanges(board).getUsersByAttachDate();

    const total = users.reduce((sum, user) => sum + this.object.getScore(user.cass.id).cass.territory, 0);

    return total / users.length / territory;
  }


};
